import { render, staticRenderFns } from "./BaseCalendarIcon.vue?vue&type=template&id=e8d8debe"
import script from "./BaseCalendarIcon.vue?vue&type=script&lang=js"
export * from "./BaseCalendarIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports